import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './Constants.css'
import axios from 'axios';
import { LOCAL_ENDPOINTS } from '../config';

class Signin extends Component {
  handleToggle = () => {
    this.props.history.push('/verified');
  }

  componentDidMount = async () => {
    let transaction_count = await axios({
      method: "GET",
      url: LOCAL_ENDPOINTS.getTransactionsCount
    });

    console.log("transaction_count::", transaction_count);
  }

  render() {
    return(
      <div className="centered-text">
        <p>WELCOME TO YOUR APP</p>
        <p> This app is used for integrating Xero functionalities. It is still under development </p>
        <div>
          <Link to="/requestAUTH-sg"> Request Authorization SG</Link>
        </div>
        <div>
          <Link to="/requestAUTH-hk"> Request Authorization HK</Link>
        </div>
        <div>
          <Link to="/requestAUTH-ms"> Request Authorization MS</Link>
        </div>
        <div>
          <Link to="/requestAUTH-au"> Request Authorization AU</Link>
        </div>
        <div>
          <Link to="/requestAUTH-uk"> Request Authorization UK</Link>
        </div>
        <div>
          <Link to="/requestAUTH-in"> Request Authorization IN</Link>
        </div>
        <div>
          <Link to="/requestAUTH-al"> Request Authorization AL</Link>
        </div>
      </div>
    )
  }
}

export default Signin;